import React from 'react';
import styles from '../branches/BranchingOpsSection.module.css';
import Ico from '../common/Ico';
import Btn from '../common/Btn';
import Pill from '../common/Pill';
import { statusLabel, statusTokens } from '../branches/statusConfig';
import { getComponentGlyph, COMPONENT_ORDER } from '../branches/BranchingOpsSection';

const ICO_TAG       = 'M20.59 13.41 12 22l-9-9-2-9 9 2 9 9a2 2 0 0 1 0 2.83z M7.5 7.5h.01';
const ICO_CHEVRIGHT = 'm9 18 6-6-6-6';

export default function PostReleaseSection({ release, onOpenOp, onTrigger }) {
  const ops = Object.entries(release.post_release_ops || {});
  const canTrigger = release.status === 'released' && !ops.length;

  const opList = ops
    .map(([component, op]) => ({ component, ...op }))
    .sort((a, b) => {
      const ia = COMPONENT_ORDER.indexOf(a.component);
      const ib = COMPONENT_ORDER.indexOf(b.component);
      return (ia === -1 ? Infinity : ia) - (ib === -1 ? Infinity : ib);
    });
  const done    = opList.filter(o => o.status === 'completed').length;
  const allDone = opList.length > 0 && done === opList.length;

  if (!canTrigger && !opList.length) return null;

  return (
    <section className={styles.section} id="sec-post-release">
      <div className={styles.header}>
        <span className={styles.iconTile}>
          <Ico d={ICO_TAG} size={16} strokeWidth={1.7} />
        </span>
        <div className={styles.headerText}>
          <div className={styles.title}>Post release</div>
          <div className={styles.subtitle}>
            Bump the application version on <code className={styles.code}>{release.branch_version}</code> now that {release.version} is released.
          </div>
        </div>
        {opList.length > 0 && (
          <Pill kind={allDone ? 'ok' : done > 0 ? 'warn' : 'neutral'} dot>
            {done} of {opList.length} bumped
          </Pill>
        )}
        {canTrigger && (
          <Btn variant="primary" size="md" icon={ICO_TAG} onClick={onTrigger}>
            Bump version
          </Btn>
        )}
      </div>

      {opList.length > 0 && (
        <div className={styles.grid}>
          {opList.map((op) => {
            const glyph  = getComponentGlyph(op.component);
            const tokens = statusTokens(op.status);
            return (
              <button
                key={op.component}
                className={styles.opCard}
                onClick={() => onOpenOp?.({ component: op.component, op })}
                type="button"
              >
                <span className={styles.opIconTile} style={{ background: glyph.bg }}>
                  {glyph.svgEl}
                </span>
                <span className={styles.opContent}>
                  <span className={styles.opName}>{op.component}</span>
                  <span className={styles.opStatus}>
                    <span className={styles.opDot} style={{ background: tokens?.dot }} />
                    <span className={styles.opStatusText}>{statusLabel(op.status)}</span>
                  </span>
                </span>
                <Ico d={ICO_CHEVRIGHT} size={13} style={{ color: 'var(--gray-400)', flexShrink: 0 }} />
              </button>
            );
          })}
        </div>
      )}
    </section>
  );
}
